// extracted by extract-css-chunks-webpack-plugin
module.exports = {"center":"app-components-staticpages-blocks-buttonblock--center"};